<template lang="pug">
  .login
    p Scan this QR code or store the secret key with an authentication app to login safely from now on. 
    p We recommend #[b Google Authenticator].
        .login-center 
            img( :src="secretUrl")
    hr
    el-form(:model="form", :rules="rules", ref="twofaForm", @submit.native.prevent="confirm")
        el-form-item(label='Enter two-factor verification code:', prop="code")
            el-input(v-model="form.code")
        el-button(type="primary", native-type="confirm", :loading="loading") Continue

</template>

<script>
import QRCode from "qrcode";
import gql from "graphql-tag";
import speakeasy from "speakeasy";

export default {
	name: "RegisterTwoFactorAuth",
	props: {
		user: {
			type: Object,
			required: true
		}
	},
	data: () => ({
		loading: false,
		secretUrl: null,
		secret: null,
		form: {
			code: null
		},
		rules: {
			code: [{ required: true, trigger: "blur", message: "Code is required" }]
		}
	}),
	mounted() {
		const secret = speakeasy.generateSecret({ length: 15 });

		QRCode.toDataURL(secret.otpauth_url, (err, data_url) => {
			this.secretUrl = data_url;
			this.secret = secret.hex;
		});
	},
	methods: {
		async confirm() {
			this.loading = true;

			try {
				await this.$refs.twofaForm.validate();

				this.$emit("submitted", this.form.code.toString());
			} catch (error) {
				return this.$message.error("Enter Two Factor verification code from an authenticator app");
			}

			try {
				if (
					!speakeasy.totp.verify({
						secret: this.secret,
						encoding: "hex",
						token: this.form.code
					})
				) {
					throw new Error("Invalid Verification Code");
				}

				await this.$apollo.mutate({
					mutation: gql`
						mutation Save2fa($input: Save2faInput!) {
							Save2fa(input: $input) {
								id
							}
						}
					`,
					variables: {
						input: { enable_2fa: true, secret_2fa: this.secret, id: this.user.id }
					}
				});

				this.$emit("submitted", this.form.code.toString());
				this.$message.success("Two factor authentication successfully set. Logging in ...");
			} catch (error) {
				this.$message.error(error.message);
				this.loading = false;
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.login {
	text-align: center;
	.login-center {
		img {
			margin: 0 auto;
			display: block;
			height: 200px;
		}
	}
}
</style>
